import { Link } from "react-router-dom";
import { ISdColDef } from "../../baseColumn/BaseColumnTypes";
import { BaseTextColumnBuilder } from "../../baseColumn/BaseTextColumn_builder";
import { REF_NUMBER_COLUMN_CONFIG } from "./RefNumberColumn_config";
import ModalContext from "../../../../../../../core/modalZ/context/ModalContext";

interface IRefNumberColumnBuilder {}

export class RefNumberColumnBuilder extends BaseTextColumnBuilder implements IRefNumberColumnBuilder {
  constructor(columnOptions?: ISdColDef<any, any>) {
    super({ ...REF_NUMBER_COLUMN_CONFIG(), ...columnOptions });
  }

  withLinkCell = (
    urlCb: (id: number | string, projectId?: number) => string,
    field: string,
    idField: string = "id"
  ) => {
    this.setColumnOptions({
      cellRenderer: params => {
        const itemId = params.data[idField];
        const mainUrl = urlCb(itemId, params.data.projectId);
        return (
          <Link key={itemId} to={`${mainUrl}`} onClick={() => ModalContext.hide()}>
            <span className="hover-link">{params.data[field]}</span>
          </Link>
        );
      }
    });
    return this;
  };
}
